import Model from "../Model";

class Companyinfo extends Model{

    buildUrl ({ param }) {
        return ['companyview/info', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Companyinfo;